module.exports = __webpack_public_path__ + "static/media/duvar@2x.339821bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/duvar@2x.png
// module id = 48
// module chunks = 0